import { navigateToApp } from '../../auth/appNavigation';
import { appUrl, isLocalAppPreview } from '../../config/appUrl';
import { Smartphone, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { storeConfig, track } from './types';

export function AppleStoreIcon() {
  return <svg className="store-button__apple" viewBox="0 0 384 512" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 131.1 4 176.9 4 270.1c0 27.5 5 55.9 15 84.9 13.4 41.7 61.7 144 112.1 142.3 26.4-.6 45-18.7 79.4-18.7 33.4 0 50.6 18.7 79.4 18.7 50.8-.7 94.2-93.7 106.9-135.6-68.2-32.2-64.7-94.8-64.3-92zm-23.2-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>;
}

function openStore(platform: 'ios' | 'android', section: string) {
  const url = platform === 'ios' ? storeConfig.ios : storeConfig.android;
  track(platform === 'ios' ? 'appstore_click' : 'googleplay_click', { source_section: section, city: storeConfig.defaultCity });
  if (url) window.location.assign(url);
}

export function StoreButtons({ section, compact = false }: { section: string; compact?: boolean }) {
  if (!storeConfig.ios && !storeConfig.android) return <a className="button button--primary" href={storeConfig.support}><Smartphone size={20} />ขอลิงก์ดาวน์โหลด</a>;
  return <div className={`store-buttons ${compact ? 'store-buttons--compact' : ''}`}>
    {storeConfig.ios && <button type="button" className="store-button store-button--app-store" aria-label="Download on the App Store" onClick={() => openStore('ios', section)}><AppleStoreIcon /><span><small>Download on the</small><strong>App Store</strong></span></button>}
    {storeConfig.android && <button className="store-button" onClick={() => openStore('android', section)}><span className="store-button__play">▶</span><span><small>GET IT ON</small><strong>Google Play</strong></span></button>}
  </div>;
}

/** A small, dismissible App Store tab shown only to Safari visitors. */
export function SafariAppInvite({ contentId }: { contentId?: string } = {}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const ua = navigator.userAgent;
    const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|Edg|OPiOS|Android/i.test(ua);
    setVisible(isSafari && Boolean(storeConfig.ios));
  }, []);
  if (!visible) return null;
  return <aside className="safari-app-invite" aria-label="ดาวน์โหลดแอป Beaw">
    <span className="safari-app-invite__icon" aria-hidden="true"><span></span></span>
    <span className="safari-app-invite__copy"><strong>ใช้ Beaw บนแอป</strong><small>{contentId ? 'เปิดโพสต์นี้ในแอป Beaw' : 'ค้นพบร้านใกล้คุณได้ง่ายขึ้น'}</small></span>
    {contentId && <a className="safari-app-invite__open" href={isLocalAppPreview() ? appUrl(`/commu/post/${encodeURIComponent(contentId)}`) : `beaw:///commu/post/${encodeURIComponent(contentId)}`}>เปิดแอป</a>}
    <a href={storeConfig.ios} target="_blank" rel="noreferrer" onClick={() => track('appstore_click', { source_section: 'safari_invite', city: storeConfig.defaultCity })}>ดาวน์โหลด</a>
    <button type="button" aria-label="ปิดคำชวนดาวน์โหลดแอป" onClick={() => setVisible(false)}><X size={16} /></button>
  </aside>;
}

export function openBeaw(section: string) {
  const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);
  const platform = /Android/i.test(navigator.userAgent) ? 'android' : /iPhone|iPad/i.test(navigator.userAgent) ? 'ios' : 'desktop';
  const event = section === 'hero' ? 'hero_open_beaw_click' : section.startsWith('map:') ? 'map_open_beaw_click' : 'final_cta_click';
  track(event, { source_section: section, city: storeConfig.defaultCity, platform });
  if (isMobile || isLocalAppPreview()) {
    void navigateToApp(appUrl());
    return;
  }
  document.getElementById('download')?.scrollIntoView({ behavior: 'smooth' });
}
